import { FC, ReactNode } from 'react';

import ItemSkeleton from 'src/pages/Profession/components/SectionCalculator/Calculator/CalculatorTablo/ItemSkeleton';

import styles from './styles.less';

interface Props {
    icon: ReactNode;
    loading: boolean;
    children: ReactNode;
}

const ItemContainer: FC<Props> = ({ icon, loading, children }) => (
    <div className={styles.itemContainer}>
        <div className={styles.itemContainerIcon}>{icon}</div>
        {loading && <ItemSkeleton />}
        {!loading && <div className={styles.itemContainerContent}>{children}</div>}
    </div>
);

export default ItemContainer;
